import { BaseIndexFieldModel, MultiTemplateTransactionalEmailTemplateModel, ReminderConfigModel } from "../../data";
import { WhatsAppTemplateParamModel } from "../../data/whatsapp/whatsapp-template-param.model";

export interface MultiTemplateTransactionalEmailTypeRequestModel {
  name: string;
  code: string | null;
  csvSeparator: string;

  emailFrom: string;
  emailFromName: string;
  mailServerId?: number | null;

  sendSms: boolean;
  smsContent?: string;

  passwordProtected: boolean;
  hasAttachment: boolean;

  archive: boolean;
  autoPurge: boolean;
  autoPurgeByDays: number;

  whatsAppTemplateName?: string | null;
  hasHtmlFile?: boolean;
  hasReminder?: boolean;
  hasAcknowledgement?: boolean;
  acknowledgementExpiryDays?: number | null;
  hasCustomAcknowledgeUrl?: boolean;
  customAcknowledgeUrl?: string | null;
  customAcknowledgeUrlSecret?: string | null;
  hasCustomExpiryUrl?: boolean;
  customExpiryUrl?: string | null;
  hasCustomLandingPage?: boolean;
  customSuccessLandingUrl?: string | null;
  customFailLandingUrl?: string | null;
  notificationEmail?: string;

  indexFields: BaseIndexFieldModel[];
  whatsAppTemplateParams?: WhatsAppTemplateParamModel[];

  transactionalEmailTemplates: MultiTemplateTransactionalEmailTemplateModel[];
  reminderConfigs?: ReminderConfigModel[];
  isTest?: boolean;
  test?: boolean;
}
